import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] pt-16 pb-8 px-4 border-t-2 border-gold" data-id="element-155">
      <div className="max-w-7xl mx-auto" data-id="element-156">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-157">
          {/* Column 1: Brand */}
          <div className="space-y-6" data-id="element-158">
            <div className="flex items-center gap-3" data-id="element-159">
              <div className="w-10 h-10 bg-dark-card border border-gold rounded flex items-center justify-center" data-id="element-160">
                <span className="text-gold font-bold text-xl" data-id="element-161">D</span>
              </div>
              <span className="text-white font-bold tracking-widest text-sm" data-id="element-162">
                DOCTOR ECOMMERCE
              </span>
            </div>
            <h3 className="text-gold font-bold text-xl" data-id="element-163">
              La cura para negocios estancados.
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-164">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
            <div className="flex gap-4" data-id="element-165">
              {/* Social Icons Placeholders */}
              <a href="#" className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center text-gold hover:bg-gold hover:text-dark transition-colors" data-id="element-166">
                IG
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center text-gold hover:bg-gold hover:text-dark transition-colors" data-id="element-167">
                FB
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center text-gold hover:bg-gold hover:text-dark transition-colors" data-id="element-168">
                IN
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center text-gold hover:bg-gold hover:text-dark transition-colors" data-id="element-169">
                TK
              </a>
            </div>
          </div>

          {/* Column 2: Servicios */}
          <div data-id="element-170">
            <h4 className="text-gold font-bold mb-6" data-id="element-171">SERVICIOS</h4>
            <ul className="space-y-4 text-gray-300 text-sm" data-id="element-172">
              <li data-id="element-173">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-174">
                  Meta Ads • Google Ads • TikTok Ads • YouTube Ads
                </a>
              </li>
              <li data-id="element-175">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-176">
                  Email • SMS • Retargeting Automatizado
                </a>
              </li>
              <li data-id="element-177">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-178">
                  Automatización con IA para Ventas 24/7
                </a>
              </li>
              <li data-id="element-179">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-180">
                  Funnels Quirúrgicos por Industria
                </a>
              </li>
              <li data-id="element-181">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-182">
                  Blindaje Digital & Anti-Ban
                </a>
              </li>
              <li data-id="element-183">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-184">
                  PR Digital & Posicionamiento en Medios
                </a>
              </li>
              <li data-id="element-185">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-186">
                  CRM & Data Tracking Avanzado
                </a>
              </li>
              <li data-id="element-187">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-188">
                  Video Marketing IA • SEO • Branding
                </a>
              </li>
              <li data-id="element-189">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-190">
                  Gestión de Reputación • Google Maps
                </a>
              </li>
              <li data-id="element-191">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-192">
                  Diseño Web • Landing Pages • CRO
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Recursos */}
          <div data-id="element-193">
            <h4 className="text-gold font-bold mb-6" data-id="element-194">RECURSOS</h4>
            <ul className="space-y-4 text-gray-300 text-sm" data-id="element-195">
              <li className="flex items-center gap-2" data-id="element-196">
                <span className="text-gray-600" data-id="element-197">›</span>{' '}
                <a href="#" className="hover:text-gold transition-colors" data-id="element-198">
                  Blog de Estrategia
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-199">
                <span className="text-gray-600" data-id="element-200">›</span>{' '}
                <a href="#" className="hover:text-gold transition-colors" data-id="element-201">
                  Casos de Éxito
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-202">
                <span className="text-gray-600" data-id="element-203">›</span>{' '}
                <a href="#" className="hover:text-gold transition-colors" data-id="element-204">
                  Política de Privacidad
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-205">
                <span className="text-gray-600" data-id="element-206">›</span>{' '}
                <a href="#" className="hover:text-gold transition-colors" data-id="element-207">
                  Términos y Condiciones
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contacto Directo */}
          <div data-id="element-208">
            <h4 className="text-gold font-bold mb-6" data-id="element-209">CONTACTO DIRECTO</h4>
            <ul className="space-y-4 text-gray-300 text-sm mb-8" data-id="element-210">
              <li className="flex items-start gap-3" data-id="element-211">
                <span className="text-gold mt-1" data-id="element-212">📍</span>
                <span data-id="element-213">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-214">
                <span className="text-gold" data-id="element-215">📞</span>
                <a href="tel:+14028720639" className="hover:text-gold transition-colors" data-id="element-216">
                  813-384-8460 / 402-872-0639
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-217">
                <span className="text-gold" data-id="element-218">✉️</span>
                <a href="mailto:doctor.ecommerceus@gmail.com" className="hover:text-gold transition-colors" data-id="element-219">
                  doctor.ecommerceus@gmail.com
                </a>
              </li>
            </ul>
            <div className="space-y-3" data-id="element-220">
              <button className="w-full bg-emerald text-white font-bold py-3 px-4 rounded flex items-center justify-center gap-2 hover:bg-emerald/80 transition-colors" data-id="element-221">
                <span data-id="element-222">💬</span> Habla con un Especialista
              </button>
              <button onClick={() => document.getElementById('contacto')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full bg-gold text-dark font-bold py-3 px-4 rounded flex items-center justify-center gap-2 hover:bg-gold/80 transition-colors" data-id="element-223">
                <span data-id="element-224">📅</span> RESERVAR DIAGNÓSTICO
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section: Partners & Mini Form */}
        <div className="border-t border-gray-800 pt-12 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8" data-id="element-225">
          <div className="w-full lg:w-1/2" data-id="element-226">
            <h5 className="text-gray-400 text-xs font-bold tracking-widest mb-4 uppercase" data-id="element-227">
              Partners Certificados y Tecnología de Élite
            </h5>
            <div className="flex flex-wrap gap-3" data-id="element-228">
              {/* Partner Badges Placeholders */}
              <div className="bg-white px-4 py-2 rounded text-xs font-bold text-black flex items-center" data-id="element-229">
                Meta Business Partner
              </div>
              <div className="bg-white px-4 py-2 rounded text-xs font-bold text-black flex items-center" data-id="element-230">
                Google Ads
              </div>
              <div className="bg-white px-4 py-2 rounded text-xs font-bold text-black flex items-center" data-id="element-231">
                Shopify Experts
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-232">
            <h5 className="text-gray-400 text-xs font-bold tracking-widest mb-4 uppercase" data-id="element-233">
              ¿Quieres que te contactemos?
            </h5>
            <form className="flex flex-col sm:flex-row gap-3" data-id="element-234">
              <input type="text" placeholder="Tu Nombre" className="bg-transparent border border-gray-700 rounded px-4 py-2 text-sm text-white focus:border-gold outline-none w-full" data-id="element-235" />
              <input type="email" placeholder="Tu Email" className="bg-transparent border border-gray-700 rounded px-4 py-2 text-sm text-white focus:border-gold outline-none w-full" data-id="element-236" />
              <input type="tel" placeholder="Tu Teléfono" className="bg-transparent border border-gray-700 rounded px-4 py-2 text-sm text-white focus:border-gold outline-none w-full" data-id="element-237" />
              <button type="button" className="bg-gold text-dark font-bold px-6 py-2 rounded hover:bg-gold/80 transition-colors whitespace-nowrap" data-id="element-238">
                ENVIAR
              </button>
            </form>
          </div>
        </div>
      </div>
    </footer>;
}